import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "message-product-card" }
const _hoisted_2 = { class: "custom-field-line" }
const _hoisted_3 = {
  key: 0,
  class: "order-name"
}
const _hoisted_4 = { class: "order-value" }
const _hoisted_5 = { class: "product-card-main" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "product-card-information" }
const _hoisted_8 = { class: "product-card-title" }
const _hoisted_9 = { class: "product-card-description-block" }
const _hoisted_10 = { class: "product-card-description" }
const _hoisted_11 = { class: "custom-field-line" }
const _hoisted_12 = {
  key: 0,
  class: "order-name"
}
const _hoisted_13 = { class: "order-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.topCustomField, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "product-card-custom-field"
      }, [
        _createElementVNode("div", _hoisted_2, [
          (item.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.name) + ": ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, _toDisplayString(item.value), 1)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_5, [
      ($setup.props.payload.content.pic)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "product-img",
            src: $setup.props.payload.content.pic
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString($setup.props.payload.content.header), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString($setup.props.payload.content.desc), 1)
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bottomCustomField, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "product-card-custom-field"
      }, [
        _createElementVNode("div", _hoisted_11, [
          (item.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.name) + ": ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, _toDisplayString(item.value), 1)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", {
      class: "product-card-link",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.jumpProductCard && $setup.jumpProductCard(...args)))
    }, _toDisplayString($setup.TUITranslateService.t("AIDesk.跳转")), 1)
  ]))
}